<template>
  <div>
    <el-row style="margin-top:20px">
      <download-excel :data="exportData" :fields="json_fields" name="存疑产品表.xls" :before-generate="startDownload"
        :before-finish="endDonload">
        <el-button> 下载存疑产品清单 </el-button>
      </download-excel>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="订单编号" prop="ORDER_CODE" min-width="50"></el-table-column>
          <el-table-column label="项目点" prop="PROJECT_NAME" min-width="50"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="50"></el-table-column>
          <el-table-column label="品牌" prop="BRAND" min-width="30"></el-table-column>
          <el-table-column label="产品名称" prop="NAME" width="100"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION" width="100"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" width="100"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>

export default {
  mounted() {
    for (const key in this.errProductList) {
      if (this.errProductList[key]) {
        this.tableData.push(...this.errProductList[key].map((item) => ({ ...item, ORDER_CODE: key })));
      }
    }
  },
  data() {
    return {
      json_fields: {
        订单编号: 'ORDER_CODE',
        项目点: 'PROJECT_NAME', // 常规字段
        产品编码: 'PRODUCT_CODE', // 支持嵌套属性
        品牌: 'BRAND',
        产品名称: 'NAME',
        规格: 'SPECIFICATION',
        单位: 'TYPE_UNIT',
      },
      exportData: [],
      errProductList: JSON.parse(sessionStorage.getItem('errProductList')),
      tableData: [],
    };
  },

  methods: {
    // 全部订单导出前的数据查询
    async startDownload() {
      this.exportData = this.tableData;
    },
    endDonload() {
      this.exportData = [];
    },
  },
};
</script>
<style scope>
.inline-input {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/thirdPartyTransferErrorProductList.vue